import React from 'react';

export const ModeIndicator = () => {
  return null;
};
